<template>
  <div class="level_rules">
    <!-- 成长值等级规则 -->
    <template v-if="gradePage == 'grade'">
      <div class="global-content-box global-content-flex">
        <div class="displayItem">
          <y-menu-title title="成长值等级规则" class="title" />
          <!-- 启用状态 -->
          <!-- 启用状态 -->
          <div class="displayItem">
            <div>
              <div v-if="isStart" class="displayItem">
                <div class="startIcon"></div>
                <span class="startTitle">启用中</span>
              </div>
              <span v-else class="offTitle">未启用</span>
            </div>

            <el-switch
              class="switch"
              v-model="isStart"
              @change="isChangeSwitch"
            >
            </el-switch>

            <y-button
              type="blueLine"
              @click="toPage('swicth')"
            >
              <img
                src="@/assets/images/memberAll/change.svg"
                alt
                style="width: 16px;height:16px; margin-right: 8px;vertical-align: middle"

              />切换等级规则方案
            </y-button>
          </div>
        </div>
        <!-- 提示语 -->
        <y-tip style="margin-top: 24px">
          <div class="tipsCont">
            1.目前触发等级重新计算的事件：成长值变更事件、更改会员升级指标
          </div>
          <div class="tipsCont">
            2.当触发会员等级计算事件发生时，会按照升级-保级-降级流程执行。
          </div>
          <div class="tipsCont">
            3.等级计算时间：当会员升级指标发生变更时，会实时重算会员等级。当修改等级规则保存后，当日晚上23：00后进行等级重算。
          </div>
          <div class="tipsCont">
            4.若升级规则、设置等级有效期为永久有效，降级规则不需要设置和变更。
          </div>
          <div class="tipsCont">
            5.配置等级计算规则前，请先配置成长值计算规则。
          </div>
        </y-tip>

        <y-title label="等级管理" style="margin-top: 16px"></y-title>

        <!-- 表格 -->
        <div class="global-felx-1">
          <y-table
            :tableInfo="tableInfo"
            :tableData="tableData"
            style="margin-top: 16px"
          >
            <template #updateLevel="scope">
              <div v-if="scope.rowIndex == 0" class="displayItem tableCont">
                最低等级，无需设置
              </div>
              <div class="displayItem" style="justify-content: flex-start" v-else>
                <div class="tableCont">
                  <div v-if="scope.row.upMorePrice">
                    等级成长值：大于等于
                    <span class="active-color">{{
                      scope.row.upMorePrice
                    }}</span>
                    成长值
                  </div>
                  <div v-else>
                    等级成长值：<span style="color: #e64c4c">未设置</span>
                  </div>
                  <div>
                    等级有效期：
                    <span class="active-color" v-if="scope.row.upTimeType == 1"
                      >自等级变更日起{{ scope.row.upTimeAfterDay }} 天后</span
                    >
                    <span
                      class="active-color"
                      v-else-if="scope.row.upTimeType == 2"
                    >
                      自等级变更日起
                      {{
                        scope.row.upTimeYear == 0 ? "当" : scope.row.upTimeYear
                      }}
                      年 {{ scope.row.upTimeMonth }} 月
                      {{ scope.row.upTimeDay }}日
                    </span>
                    <span class="active-color" v-else>长期有效</span>
                  </div>
                </div>
                <div @click="editUpgradation(scope.row, scope.rowIndex)">
                  <img
                    src="@/assets/images/memberAll/edit.png"
                    alt
                    style="width: 14px; cursor: pointer"
                  />
                </div>
              </div>
            </template>
            <template #bLevel="scope">
              <div v-if="scope.rowIndex == 0" class="displayItem tableCont">
                最低等级，无需设置
              </div>
              <div
                v-else-if="scope.row.upTimeType == 3"
                class="displayItem tableCont"
              >
                等级长期有效，无需设置
              </div>
              <div class="displayItem" style="justify-content: flex-start" v-else>
                <div class="tableCont">
                  <div v-if="scope.row.reIsOpen">
                    执行保级条件：大于等于<span class="active-color">{{
                      scope.row.reMorePrice
                    }}</span>
                    成长值
                    <div>
                      等级有效期：
                      <span
                        class="active-color"
                        v-if="scope.row.reTimeType == 1"
                        >自等级变更日起{{ scope.row.reTimeAfterDay }} 天后</span
                      >
                      <span
                        class="active-color"
                        v-else-if="scope.row.reTimeType == 3"
                      >
                        自等级变更日起
                        {{
                          scope.row.reTimeYear == 0 ? "当" : scope.row.reTimeYear
                        }}
                        年 {{ scope.row.reTimeMonth }} 月
                        {{ scope.row.reTimeDay }}日
                      </span>
                      <span class="active-color" v-else
                        >当月的{{ scope.row.reTimeDay }}日过期</span
                      >
                    </div>
                  </div>
                  <div v-else>尚未启用，系统不会校验此规则</div>
                </div>
                <div @click="editRelegation(scope.row)">
                  <img
                    src="@/assets/images/memberAll/edit.png"
                    alt
                    style="width: 14px; cursor: pointer"
                  />
                </div>
              </div>
            </template>
            <template #jLevel="scope">
              <div v-if="scope.rowIndex == 0" class="displayItem tableCont">
                最低等级，无需设置
              </div>
              <div
                v-else-if="scope.row.upTimeType == 3"
                class="displayItem tableCont"
              >
                等级长期有效，无需设置
              </div>
              <div class="displayItem" style="justify-content: flex-start" v-else>
                <div class="tableCont">
                  <div v-if="scope.row.downType == 2">
                    到期降级为：Lv.{{ scope.row.downToLevel }}
                  </div>
                  <div v-else>
                    根据等级生效之日至等级到期期间内，<br />
                    所获得成长值重新计算会员等级
                  </div>
                </div>
                <div @click="editReduce(scope.row, scope.rowIndex)">
                  <img
                    src="@/assets/images/memberAll/edit.png"
                    alt
                    style="width: 14px; cursor: pointer"
                  />
                </div>
              </div>
            </template>
          </y-table>
        </div>
      </div>
    </template>

    <!-- 切换页 -->
    <template v-if="gradePage == 'swicth'">
      <switchlevel @toPage="toPage" :upRuleType="upRuleType"></switchlevel>
    </template>

    <!-- 行为等级规则 -->
    <template v-if="gradePage == 'behavior'">
      <behaviorlevel
        @toPage="toPage"
        :upRuleType="upRuleType"
        @changeUpRuleType="changeUpRuleType"
      ></behaviorlevel>
    </template>

    <!-- 弹窗-升级规则设置 -->
    <y-dialog
      title="升级规则设置"
      :visible.sync="upgradationDialog"
      width="800px"
      sureText="保存"
      @comfirm="saveUpgrada()"
      @close="cancelBtn()"
    >
      <el-form
        :model="upRuleForm"
        ref="upRuleForm"
        :rules="rules"
        label-width="110px"
      >
        <el-form-item label="等级成长值：" prop="upMorePrice" required>
          大于等于
          <el-input
            v-model="upRuleForm.upMorePrice"
            class="dialogItem"
            oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
            @change="inputChange($event, 'upMorePrice', 'up')"
          ></el-input>
          成长值
        </el-form-item>
        <el-form-item label="等级有效期：" prop="region">
          <el-radio-group v-model="upRuleForm.upTimeType">
            <el-radio :label="1" style="margin: 0 0 6px 0">
              自等级变更日起
              <el-input
                v-model.number="upRuleForm.upTimeAfterDay"
                class="dialogItem"
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                @change="inputChange($event, 'upTimeAfterDay', 'up')"
              ></el-input>
              天后等级过期
            </el-radio>
            <el-radio :label="2" style="margin: 6px 0">
              自等级变更日起
              <el-select class="dialogItem" v-model="upRuleForm.upTimeYear">
                <el-option
                  v-for="item in yearList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              的
              <el-select class="dialogItem" v-model="month">
                <el-option
                  v-for="item in monthList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              月
              <el-select class="dialogItem" v-model="upRuleForm.upTimeDay">
                <el-option
                  v-for="item in dayList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              日0点等级过期
            </el-radio>
            <el-radio :label="3" style="margin: 6px 0;display:block">永不过期</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </y-dialog>

    <!-- 弹窗-保级规则设置-->
    <y-dialog
      title="保级规则设置"
      :visible.sync="relegationDialog"
      width="800px"
      sureText="保存"
      @comfirm="saveBtn()"
      @close="cancelBtn()"
    >
      <y-tip>
        <div class="tipsCont">
          1.会员在当前等级达到已设置的保级门槛条件，则会根据配置为会员保留当前等级；如达到保级门槛条件时，已过预设保级时间，则顺延至次月或次年。
        </div>
        <div class="tipsCont">
          2.选择保级时长设置方式为“当月X日0点过期”：则若当月无设置的时间，则默认为该月的最后一天，例如设置30号，当月只有28号则28号日0点过期
        </div>
      </y-tip>
      <el-form
        :model="reRuleForm"
        :rules="rules"
        ref="reRuleForm"
        label-width="120px"
        style="margin-top: 16px"
      >
        <el-form-item label="是否启用保级：">
          <el-switch
            v-model="reRuleForm.reIsOpen"
            :active-value="activeValue"
            :inactive-value="inactiveValue"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="保级规则：" required>
          大于等于
          <el-input
            v-model="reRuleForm.reMorePrice"
            class="dialogItem"
            oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
            @change="inputChange($event, 'reMorePrice', 're')"
          ></el-input>
          成长值
        </el-form-item>
        <el-form-item label="保级时长：" prop="region">
          <el-radio-group v-model="reRuleForm.reTimeType">
            <el-radio :label="1" style="margin: 0 0 6px 0; width: 100%">
              <el-input
                v-model.number="reRuleForm.reTimeAfterDay"
                class="dialogItem"
                @change="inputChange($event, 'reTimeAfterDay', 're')"
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
              ></el-input>
              天后等级过期
            </el-radio>
            <el-radio :label="2" style="margin: 6px 0; width: 100%">
              当月的
              <el-select
                class="dialogItem"
                v-model="mouthDay"
                style="width: 60px"
                placeholder=" "
              >
                <el-option
                  v-for="item in moneyDayList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              日0点等级过期
            </el-radio>
            <el-radio :label="3" style="margin: 10px 0; width: 100%">
              <el-select class="dialogItem" v-model="reRuleForm.reTimeYear">
                <el-option
                  v-for="item in yearList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              的
              <el-select
                class="dialogItem"
                v-model="month"
                style="width: 60px"
                placeholder=" "
              >
                <el-option
                  v-for="item in monthList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              月
              <el-select
                class="dialogItem"
                v-model="reRuleForm.reTimeDay"
                style="width: 60px"
                placeholder=" "
              >
                <el-option
                  v-for="item in dayList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              日0点等级过期
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </y-dialog>

    <!-- 弹窗-降级规则设置 -->
    <y-dialog
      title="降级规则设置"
      :visible.sync="reduceDialog"
      width="800px"
      sureText="保存"
      @comfirm="saveDownBtn()"
      @close="cancelBtn()"
    >
      <y-tip> 规则执行的顺序依次为： 升级 → 保级 →降级 </y-tip>
      <el-form
        :model="downRruleForm"
        :rules="rules"
        ref="downRruleForm"
        style="margin-top: 16px"
      >
        <el-form-item>
          <el-radio-group v-model="downRruleForm.downType">
            <el-radio
              :label="Number(1)"
              :value="Number(1)"
              style="margin: 0 0 6px 0; width: 100%"
            >
              根据等级生效之日至等级到期期间内，所获得成长值重新计算会员等级
            </el-radio>
            <el-radio
              :label="Number(2)"
              :value="Number(2)"
              style="margin: 6px 0; width: 100%"
            >
              等级到期时，则降级为
              <el-select
                class="dialogItem"
                v-model="downRruleForm.downToLevel"
                placeholder=" "
              >
                <el-option
                  v-for="item in levelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </y-dialog>
  </div>
</template>

<script>
import {
  getGradeList,
  saveGrade,
  getScoresCardUpRuleType,
  upRuleSwitch,
} from "@/api/manage/scoreList";
import router from "../../router";
import { getDetailById } from "@/api/integralCenter/newMemberSystem";
import switchlevel from "./prop/switch_level.vue";
import behaviorlevel from "./prop/behavior_level.vue";
export default {
  components: {
    switchlevel,
    behaviorlevel,
  },
  data() {
    return {
      isStart: false, //是否启用规则
      gradePage: "grade", //显示哪个页面
      upRuleType: 1, //等级升级规则类型
      MemberSystemInfo: {},
      tableData: [],
      upgradationDialog: false, //升级规则设置弹窗
      relegationDialog: false, //保级规则设置弹窗
      reduceDialog: false, //降级规则设置弹窗
      upRuleForm: {
        //升级
        upMorePrice: 0, //成长值
        upTimeType: 1, //类型
        upTimeAfterDay: 1,
        upTimeDay: 1,
        upTimeMonth: 1,
        upTimeYear: 0,
      },
      reRuleForm: {
        //保级
        reIsOpen: 0,
        reTimeType: 1,
        reMorePrice: 0,
        reTimeAfterDay: 1,
        reTimeYear: 1,
        reTimeMonth: 1,
        reTimeDay: 1,
      },
      downRruleForm: {
        //降级
        downType: 1,
        downToLevel: "",
      },
      month: 1,
      mouthDay: 1,
      yearList: [
        {
          value: 0,
          label: "当年",
        },
        {
          value: 1,
          label: "1年后",
        },
        {
          value: 2,
          label: "2年后",
        },
        {
          value: 3,
          label: "3年后",
        },
        {
          value: 4,
          label: "4年后",
        },
        {
          value: 5,
          label: "5年后",
        },
      ],
      rules: {
        upMorePrice: [{ required: true, message: "不能为空" }],
      },
      monthList: [],
      dayList: [],
      moneyDayList: [],
      levelList: [],
      nowGrade: 0, //当前修改等级
      activeValue: 1,
      inactiveValue: 0,
      // minNum:0,
      // maxNum:null,

      tableInfo: [
        {
          label: "等级",
          prop: "level",
        },
        {
          label: "升级",
          prop: "level",
          slot: "updateLevel",
        },
        {
          label: "保级",
          prop: "level",
          slot: "bLevel",
        },
        {
          label: "降级",
          prop: "level",
          slot: "jLevel",
        },
      ],
    };
  },
  watch: {
    month: function () {
      if (
        this.month === 1 ||
        this.month === 3 ||
        this.month === 5 ||
        this.month === 7 ||
        this.month === 8 ||
        this.month === 10 ||
        this.month === 12
      ) {
        this.dayList = [];
        for (let i = 1; i <= 31; i++) this.dayList.push(i);
      } else if (this.month === 2) {
        this.dayList = [];
        for (let i = 1; i <= 28; i++) this.dayList.push(i);
        if (this.upRuleForm.upTimeDay > 28) {
          this.upRuleForm.upTimeDay = 28;
        }
        if (this.reRuleForm.reTimeDay > 28) {
          this.reRuleForm.reTimeDay = 28;
        }
      } else {
        this.dayList = [];
        for (let i = 1; i <= 30; i++) this.dayList.push(i);
      }
    },
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "忠诚度管理", "等级计划规则");
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log("this.MemberSystemInfo", this.MemberSystemInfo);
  },
  mounted() {
    this.initDate();
    this.getScoresType();
  },
  methods: {
    //查询会员卡等级升级类型
    getScoresType() {
      getScoresCardUpRuleType({
        cardId: this.MemberSystemInfo.scoresCardId,
      }).then((res) => {
        this.upRuleType = res.data;
        // 1 行为等级 2 成长值规则 空则表示未配置
        if (res.data == 2) {
          this.gradePage = "grade";
          this.isStart = true;
          this.getActivityList();
        } else if (res.data == 1) {
          this.gradePage = "behavior";
        } else {
          this.gradePage = "swicth";
        }
      });
    },
    // 获取会员体系详情
    getDetailById() {
      getDetailById({
        cardId: this.$store.state.MemberSystemInfo.scoresCardId,
      }).then((res) => {
        // res.gradeList.gradeName
        // let arr =[]
        // this.tableData.forEach((item,index) => {
        //   arr.push({...item,level: res.data.gradeList[index].gradeName});
        // });
        this.tableData = this.tableData.map((item, index) => {
          return { ...item, level: res.data.gradeList[index].gradeName };
        });
        console.log("this.tableData", this.tableData);
      });
    },
    // 获取活动列表
    getActivityList() {
      getGradeList({ scoresCardId: this.MemberSystemInfo.scoresCardId }).then(
        (res) => {
          this.tableData = res.data;
          this.getDetailById();
          // this.tableData = res.data.map((item,index) => {
          //     return { ...item, level: 'Lv.'+(index+1)};
          //   });
        }
      );
    },
    //升级规则设置弹窗
    editUpgradation(item, index) {
      // this.minNum = this.tableData[index-1]? this.tableData[index-1].upMorePrice : 0
      // this.maxNum = this.tableData[index+1]? this.tableData[index+1].upMorePrice : null;
      this.nowGrade = item.grade;
      this.month = item.upTimeMonth;
      this.upRuleForm = { ...item };
      this.upRuleForm.scoresCardRuleId = item.scoresCardRuleId;
      this.upgradationDialog = true;
    },
    //保级规则设置弹窗
    editRelegation(item) {
      this.reRuleForm = { ...item };
      if (!this.reRuleForm.reTimeType) {
        this.reRuleForm.reTimeType = 1;
      }
      console.log("99", this.reRuleForm);
      this.month = item.reTimeMonth || 1;
      this.mouthDay = item.reTimeDay;
      this.nowGrade = item.grade;
      this.reRuleForm.scoresCardRuleId = item.scoresCardRuleId;
      this.relegationDialog = true;
    },
    //降级规则设置弹窗
    editReduce(item, index) {
      this.levelList = [];
      for (let i = 1; i <= index; i++) {
        this.levelList.push({
          label: "Lv." + i,
          value: i,
        });
      }
      this.downRruleForm.scoresCardRuleId = item.scoresCardRuleId;
      this.downRruleForm = { ...item };
      this.nowGrade = item.grade;
      this.reduceDialog = true;
    },
    //保存保级
    saveBtn() {
      this.reRuleForm.reTimeMonth = Number(this.month);
      if (this.reRuleForm.reIsOpen == 1) {
        if (!this.reRuleForm.reMorePrice) {
          this.$message.warning("请输入保值成长值");
          return;
        }

        // for(let i=0;i<this.nowGrade-1;i++){
        //   if(this.reRuleForm.reMorePrice<=this.tableData[i].reMorePrice){
        //     this.$message.warning('保值成长值设置要大于低级别设置的保值成长值');
        //   return;
        //   }
        // }

        // for(let i=this.nowGrade;i<this.tableData.length;i++){
        // if( Number(this.tableData[i].reMorePrice) && Number(this.reRuleForm.reMorePrice) > Number(this.tableData[i].reMorePrice) ){
        //   this.$message.warning('成长值设置要小于高级别设置的等级成长值');
        //   return;
        // }
        // }

        if (
          !this.reRuleForm.reTimeAfterDay &&
          this.reRuleForm.reTimeType == 1
        ) {
          this.$message.warning("请正确输入保级有效期");
          return;
        }

        if (this.reRuleForm.reTimeType == 2) {
          this.reRuleForm.reTimeDay = Number(this.mouthDay);
          if (!this.reRuleForm.reTimeDay) {
            this.$message.warning("请正确输入保级有效期");
            return;
          }
        }

        if (this.reRuleForm.reTimeType == 3) {
          if (
            (!this.reRuleForm.reTimeYear && this.upRuleForm.reTimeYear != 0) ||
            !this.reRuleForm.reTimeMonth ||
            this.reRuleForm.reTimeMonth == 0 ||
            !this.reRuleForm.reTimeDay
          ) {
            this.$message.warning("请正确输入保级有效期");
            return;
          }
        }
      }
      this.reRuleForm.reMorePrice = Number(this.reRuleForm.reMorePrice);
      this.reRuleForm.grade = this.nowGrade;
      saveGrade(this.reRuleForm).then((res) => {
        if (res.code == 200) {
          this.relegationDialog = false;
          this.getActivityList();
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //保存升级
    saveUpgrada() {
      this.upRuleForm.upTimeMonth = Number(this.month);
      if (!this.upRuleForm.upMorePrice) {
        this.$message.warning("请输入成长值");
        return;
      }
      for (let i = 0; i < this.nowGrade - 1; i++) {
        if (
          Number(this.upRuleForm.upMorePrice) <=
          Number(this.tableData[i].upMorePrice)
        ) {
          this.$message.warning("成长值设置要大于低级别设置的等级成长值");
          return;
        }
      }

      for (let i = this.nowGrade; i < this.tableData.length; i++) {
        if (
          Number(this.tableData[i].upMorePrice) &&
          Number(this.upRuleForm.upMorePrice) >
            Number(this.tableData[i].upMorePrice)
        ) {
          this.$message.warning("成长值设置要小于高级别设置的等级成长值");
          return;
        }
      }
      console.log("this.upRuleForm.", this.upRuleForm);
      if (!this.upRuleForm.upTimeAfterDay && this.upRuleForm.upTimeType == 1) {
        this.$message.warning("请输入等级有效期");
        return;
      }

      if (this.upRuleForm.upTimeType == 2) {
        if (
          (!this.upRuleForm.upTimeYear && this.upRuleForm.upTimeYear != 0) ||
          !this.upRuleForm.upTimeMonth ||
          this.upRuleForm.upTimeMonth == 0 ||
          !this.upRuleForm.upTimeDay
        ) {
          this.$message.warning("请输入等级有效期");
          return;
        }
      }
      this.upRuleForm.upMorePrice = Number(this.upRuleForm.upMorePrice);
      this.upRuleForm.grade = this.nowGrade;
      saveGrade(this.upRuleForm).then((res) => {
        if (res.code == 200) {
          this.upgradationDialog = false;
          this.getActivityList();
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //保存降级设置
    saveDownBtn() {
      if (this.downRruleForm.downType == 2 && !this.downRruleForm.downToLevel) {
        this.$message.warning("请输入降级等级");
        return;
      }
      this.downRruleForm.grade = this.nowGrade;
      saveGrade(this.downRruleForm).then((res) => {
        if (res.code == 200) {
          this.reduceDialog = false;
          this.getActivityList();
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //时间组件
    initDate() {
      for (let i = 1; i <= 12; i++) {
        this.monthList.push(i);
      }
      for (let i = 1; i <= 31; i++) {
        this.dayList.push(i);
      }
      for (let i = 1; i <= 31; i++) {
        this.moneyDayList.push(i);
      }
      for (let i = 1; i <= 5; i++) {
        this.levelList.push({
          label: "等级" + i,
          value: i,
        });
      }
    },
    // 取消弹窗
    cancelBtn() {
      this.upgradationDialog = false;
      this.relegationDialog = false;
      this.reduceDialog = false;
    },
    // 输入限制
    inputChange(e, name, type) {
      console.log("e", e);
      if (e == 0) {
        this.$message.warning("不能输入0");
        if (type == "up") {
          this.upRuleForm[name] = null;
        } else if (type == "re") {
          this.reRuleForm[name] = null;
        }
      }
    },
    //跳转到切换页面
    toPage(name) {
      this.gradePage = name;
    },
    changeUpRuleType(val) {
      console.log("upRuleType", val);
      this.upRuleType = val;
    },
    //改变启用状态
    isChangeSwitch() {
      let newType = this.isStart;
      this.isStart = false;
      console.log(" this.upRuleType2", this.upRuleType);
      if (this.upRuleType == 1) {
        this.isStart = false;
        this.$message.warning("启用失败: 启用成长值等级规则需关闭行为等级规则");
      } else {
        let params = {
          cardId: this.$store.state.MemberSystemInfo.scoresCardId,
          upRuleType: 2,
          state: newType,
        };
        upRuleSwitch(params).then((res) => {
          if (newType) {
            this.isStart = true;
            this.upRuleType = 2;
            this.$message.warning("启用成功");
          } else {
            this.isStart = false;
            this.$message.warning("修改成功");
            this.upRuleType = "";
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.level_rules{
  height: 100%;
}
.active-color {
  color: $theme-color;
}

.displayItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.title {
  margin-bottom: 0px;
  margin-right: 24px;
}

.switch {
  margin: 0px 24px;
}

.dialogItem {
  width: 100px;
  margin: 0 5px;
}
</style>